var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1891_16409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21H9.5C9.224 21 9 20.776 9 20.5C9 20.224 9.224 20 9.5 20H13.5C14.327 20 15 19.327 15 18.5V13.5C15 13.224 15.224 13 15.5 13C15.776 13 16 13.224 16 13.5V18.5C16 19.878 14.879 21 13.5 21Z",
    fill: "#848080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11H13.5C13.224 11 13 10.776 13 10.5C13 10.224 13.224 10 13.5 10H23.5C23.776 10 24 10.224 24 10.5C24 10.776 23.776 11 23.5 11Z",
    fill: "#848080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24C7.78 24 7.565 23.963 7.362 23.891L1.372 21.894C0.552 21.621 0 20.859 0 20V2C0 0.897 0.897 0 2 0C2.222 0 2.438 0.037 2.639 0.11L8.628 2.106C9.448 2.378 10 3.14 10 4V22C10 23.103 9.103 24 8 24ZM2 1C1.448 1 1 1.449 1 2V20C1 20.428 1.276 20.808 1.688 20.946L7.688 22.946C8.344 23.179 9 22.654 9 22V4C9 3.571 8.724 3.191 8.312 3.055L2.312 1.055C2.209 1.018 2.104 1 2 1Z",
    fill: "#848080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8C15.224 8 15 7.776 15 7.5V2.5C15 1.673 14.327 1 13.5 1H2C1.724 1 1.5 0.776 1.5 0.5C1.5 0.224 1.724 0 2 0H13.5C14.879 0 16 1.122 16 2.5V7.5C16 7.776 15.776 8 15.5 8Z",
    fill: "#848080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5003 14.9983C19.3723 14.9983 19.2443 14.9493 19.1463 14.8523C18.9512 14.6573 18.9512 14.3403 19.1463 14.1453L22.7923 10.4993L19.1463 6.85325C18.9512 6.65825 18.9512 6.34125 19.1463 6.14625C19.3413 5.95125 19.6583 5.95125 19.8533 6.14625L23.8533 10.1463C24.0483 10.3413 24.0483 10.6583 23.8533 10.8533L19.8533 14.8533C19.7563 14.9493 19.6283 14.9983 19.5003 14.9983Z",
    fill: "#848080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1891_16409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.3e36fc7d03b5dfd0425807b6ff9425d4.svg";
export { ForwardRef as ReactComponent };